export default "__VITE_ASSET__4178178d__"